import "./Resume.css"
const Resume = () => {
    return (
        <>
            <h2 className={"header"}>Resume:</h2>
            <div className={"mainTextbox"}>
                <h3>Education:</h3>
                <b>Texas State University</b>
                <p>Bachelor of Science in Computer Science<br/>
                    Minor in Applied Mathematics<br/>
                    Graduated May 2023</p>
            </div>
            <div className={"mainTextbox"}>
                <h3>Work Experience:</h3>

                <b>Software Developer IV @ <a href={"https://www.paycom.com/"}>Paycom Software, Inc.</a></b>
                <b>June 2023 - Present</b>
                <ul>
                    <li>Own end-to-end development of full-stack features, designing React-based frontend pages, RESTful API endpoints, and PHP backend services in a large-scale enterprise payroll platform.</li>
                    <li>Took ownership and lead development of the international payroll validation system that generates and submits filings to international government agencies, processes response data, and presents results in a clear, actionable UI for clients.</li>
                    <li>Build and maintain high-traffic, business-critical pages, including payroll check register validation and employee payroll approval flows used by thousands of clients and employees prior to payroll finalization.</li>
                    <li>Collaborate directly with product managers and engineering leadership to define project scope, design technical solutions, and deliver new features for international payroll clients.</li>
                    <li>Implement asynchronous workflows using RabbitMQ and integrate with services leveraging MySQL, Amazon S3, and Swagger-documented APIs.</li>
                    <li>Maintain and modernize a hybrid legacy and modern codebase, improving stability while incrementally migrating older jQuery pages toward React-based solutions.</li>
                    <li>Mentor junior developers through code reviews, technical guidance, and onboarding support, contributing to improved code quality and team velocity.</li>
                    <li>Investigate and resolve client-reported issues, performing root-cause analysis and delivering timely fixes to production systems.</li>
                </ul>

                <b>Front-End Web Developer @ <a href={"https://spexodisks.com/"}>SpexoDisks</a></b>
                <b>January 2023 - June 2023</b>
                <ul>
                    <li>Designed and built reusable UI components to ensure consistency and scalability across a scientific data-sharing web platform.</li>
                    <li>Improved layout responsiveness and accessibility, optimizing the UI for a wide range of screen sizes and devices.</li>
                    <li>Partnered with project leaders to translate product ideas and requirements into production-ready frontend components</li>
                </ul>

                <b>Software Development Intern @ <a href={"https://www.paycom.com/"}>Paycom Software, Inc.</a></b>
                <b>May 2022 - August 2022</b>
                <ul>
                    <li>Built a responsive React SPA powered by a PHP backend and MySQL database, enabling dynamic data retrieval and real-time UI updates.</li>
                    <li>Designed relational database tables to support scalable, dynamic UI functionality.</li>
                    <li>Modernized legacy PHP code to introduce real-time data updates and optimize DB query performance.</li>
                    <li>Used GitLab, Jira, and Confluence to plan, track, and document development work collaboratively.</li>
                </ul>
                <b>Student Worker @ <a href={"https://marketing.mccoy.txst.edu/"}>The Department of Marketing at Texas State University</a></b>
                <b>August 2019 - December 2022</b>
                <ul>
                    <li>Over 3 years of work experience in a professional office setting.</li>
                    <li>Assisted students with questions regarding staff and courses.</li>
                    <li>Assisted staff with various tasks relating to their courses.</li>
                    <li>Set up various forms of technology, such as computers and printers, for the office and staff.</li>
                    <li>Maintained the office’s cleanliness and restocked supplies.</li>
                </ul>
                <b>References</b>
                <ul>
                    <li>Aditya Dave - Technical Lead - Phone: 979-739-0411</li>
                    <li>Dr. Caleb Wheeler – Detector Readout Development Scientist - Phone: 314-283-8383</li>
                    <li>Tecpal SolisRayos - Previous Team Lead and mentor - Phone: 915-990-5187</li>
                    <li>Cheryl Contreras - Previous Employer - Work Phone: 512-245-7467</li>
                </ul>
            </div>
            <div className={"mainTextbox"}>
                <h3>Relevant Coursework:</h3>
                <b>Data Structures & Algorithms</b>
                <ul>
                    <li>Gathered a more comprehensive look at advanced data structures and basic common algorithms.</li>
                    <li>Implemented the use of data structures and algorithms on those data structures in C++.</li>
                    <li>Introduction to advanced algorithms such as Dijkstra’s graph algorithm.</li>
                </ul>
                <b>Fundamentals of Algorithms Design and Analysis</b>
                <ul>
                    <li>Conducted through the Engineer in Residence program in collaboration with Facebook.</li>
                    <li>Gained a more in-depth look into popular advanced algorithms and their functions commonly used in
                        software engineering.</li>
                    <li>Implemented advanced algorithms to solve common problems in C++.</li>
                </ul>
            </div>
            <div className={"mainTextbox"}>
                <h3>Projects:</h3>
                <b>Space Vision</b>
                <ul>
                    <li>Frontend Website created using React and multiple UI libraries to present the user with a modern looking website.</li>
                    <li>Displayed data from NASA’s open APIs to allow the user to easily view the data.</li>
                    <li>Project was created by a team of four and progress was managed using Jira and Bitbucket.</li>
                    <li>Version control and merging of changes was completed using Git.</li>
                    <li>Website was hosted on a personal Linux machine using Apache HTTP Server Software.</li>
                </ul>
                <b>Parallel Lossless Audio Codec (PLAC)</b>
                <ul>
                    <li>Lossless audio codec aimed at WAV file compression and decompression.</li>
                    <li>Utilizes the parallel capabilities of the CPU and GPU using OpenMP and the CUDA Framework.</li>
                    <li>Both the CPU and GPU codecs are compatible with each other.</li>
                    <li>Achieves higher throughput compared to ALAC, FLAC, and WavPack.</li>
                    <li>The research project received the CS Research Excellence Award from Texas State University.</li>
                </ul>
            </div>
            <div className={"mainTextbox"}>
                <h3>Technical Skills:</h3>
                <b>Programming Languages:</b>
                <p>C++, PHP, JavaScript, C#, SQL, Bash, Python, HTML, CSS</p>
                <b>Frameworks and Technologies:</b>
                <p>React, jQuery, .Net, Linux, RabbitMQ, Swagger, Git, Amazon S3, GitLab CI/CD, Docker, IIS, Couchbase.</p>
            </div>

        </>
    )
}
export default Resume;